import {AIProvider, AIProviderSettings} from "../AIProvider";
import {useState} from "react";
import {Checkbox, Flex, Input, Space} from "antd";

export const CommonSettings = (props: {
    provider: AIProvider,
    settings: AIProviderSettings,
    onChange: (settings: AIProviderSettings) => void
}) => {
    const [apiKey, setApiKey] = useState(props.settings.apiKey)
    const [models, setModels] = useState<string[]>(props.settings.models)

    return (
        <Flex gap={10} >
            <Flex vertical={true} gap={12} style={{paddingTop:5}}>
                <div><b>API Key:</b></div>
                <div><b>Models:</b></div>
            </Flex>
            <Space direction={'vertical'} style={{flexGrow:1}}>
                <Input placeholder="API Key" value={apiKey} onChange={e => {
                    setApiKey(e.target.value)
                    props.onChange({...props.settings, apiKey: e.target.value, models: models})
                }}/>
                {props.provider.models.map((model, index) => <Checkbox key={index}
                    checked={models.includes(model)}
                    onChange={(e) => {
                        const m = e.target.checked ? models.concat(model) : models.filter(m => m != model)
                        setModels(m)
                        props.onChange({...props.settings, apiKey: apiKey, models: m})
                    }}>{model}</Checkbox>)
                }
            </Space>
        </Flex>
    )
}